import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-hourly-fleet-utilization',
	templateUrl: './hourly-fleet-utilization.component.html',
	styleUrls: ['./hourly-fleet-utilization.component.css']
})
export class HourlyFleetUtilizationComponent {
	@Input() data: any = {};
	@Input() devices: any = {};

	chart = {
		firstChartTitle: this.translate.instant('utilization.hourly_fleet_utilization'),
		secondChartTitle: this.translate.instant('utilization.hourly_percent_fleet_utilization'),
		dateFormate: "yyyy-MM-dd HH:mm"
	}

	constructor(
		private translate: TranslateService
	) {}
}
